export default "__VITE_ASSET__Dwvoj6Ae__"